module.exports = __webpack_public_path__ + "static/img/dark-history.b239efc3.png";